module.exports = __webpack_public_path__ + "static/media/Streamer01-1040-400.a2cf7af1.jpg";